import { render, staticRenderFns } from "./advApiUrl.vue?vue&type=template&id=0c53e920&scoped=true"
import script from "./advApiUrl.vue?vue&type=script&lang=js"
export * from "./advApiUrl.vue?vue&type=script&lang=js"
import style0 from "./advApiUrl.vue?vue&type=style&index=0&id=0c53e920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c53e920",
  null
  
)

export default component.exports